module.exports = __webpack_public_path__ + "static/img/auth-bg.be350ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth-bg.jpg
// module id = 9lqd
// module chunks = 0